import { Box, Collapse, HoverCard, Stack } from "@mantine/core";
import { IconForms, IconMailForward } from "@tabler/icons-react";
import { useLanguage } from "../../stores/LanguageStore";
import NavItemMenu from "./NavItemMenu";
import { LinksGroup } from "./NavbarLinksGroup/NavbarLinksGroup";
import { useUIStore } from "../../stores/UIStore";
import IconModels from "../../assets/icons/IconModels";
import { useMemo } from "react";
import { getPermission } from "../../functions/utilFunctions";

const Ressources = ({ navbarClosed, opened, setOpened }) => {
  const lang = useLanguage((s) => s.language);

  const ressources = useMemo(() => {
    let result = [
      {
        id: "models",
        path: "/models",
        icon: IconMailForward,
        name: lang.navbar.messages,
        // name: lang.header.navigations.models.label,
      },
    ];

    if (getPermission("displayForms")) {
      result.push({
        id: "forms",
        name: lang.navbar.forms,
        icon: IconForms,
        path: "/forms",
      });
    }

    return result;
  }, [lang.navbar.forms, lang.navbar.messages]);

  return navbarClosed ? (
    <HoverCard position="right-start" offset={4} width={240}>
      <HoverCard.Target>
        <Box>
          <LinksGroup
            closed={navbarClosed}
            name={lang.navbar.models}
            onClick={() => {
              if (useUIStore.getState().navbarClosed) {
                useUIStore.getState().setNavbarClosed(false);
                setOpened(true);
              } else {
                setOpened(!opened);
              }
            }}
            icon={IconModels}
            navbarClosed={navbarClosed}
            hasLinks={true}
            opened={opened}
            path={"/models"}
            secondPath="/forms"
            id={"nav-ressources"}
            noNav
          />
        </Box>
      </HoverCard.Target>

      <HoverCard.Dropdown>
        <Stack py={0} mx={-16} gap={0}>
          {ressources.map((item) => (
            <LinksGroup
              key={item.id}
              id={item.id}
              path={item.path}
              icon={item.icon}
              name={item.name}
              navbarClosed={closed}
            />
          ))}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  ) : (
    <>
      <LinksGroup
        closed={navbarClosed}
        name={lang.navbar.models}
        onClick={() => {
          if (useUIStore.getState().navbarClosed) {
            useUIStore.getState().setNavbarClosed(false);
            setOpened(true);
          } else {
            setOpened(!opened);
          }
        }}
        icon={IconModels}
        navbarClosed={navbarClosed}
        hasLinks={true}
        opened={opened}
        id={"nav-ressources"}
        path={"/models"}
        secondPath="/forms"
        noNav
      />

      <Collapse in={opened}>
        {ressources.map((link) => (
          <NavItemMenu
            is2
            key={link.path}
            item={link}
            navbarClosed={navbarClosed}
          />
        ))}
      </Collapse>
    </>
  );
};

export default Ressources;
